import VwKurumMailGonderimAyarlariDTO from "src/models/Settings/Generals/VwKurumMailGonderimAyarlariDTO";
import api from "../core/api";

const controllerName = "KurumMailGonderimAyarlari";

const KurumMailGonderimAyarlariApi = api.injectEndpoints({
    endpoints: (builder) => ({
        KurumMailGonderimAyarlariListesi: builder.query<Array<VwKurumMailGonderimAyarlariDTO>, void>({
            query: (request) => {
                return {
                    url: controllerName + "/KurumMailGonderimAyarlariListesi",
                    method: "GET",
                }
            },
            providesTags: ["KurumMailGonderimAyarlari"]
        }),
        KurumMailGonderimAyarEkle: builder.mutation<VwKurumMailGonderimAyarlariDTO, VwKurumMailGonderimAyarlariDTO>({
            query: (request) => {
                return {
                    url: controllerName + "/KurumMailGonderimAyarEkle",
                    method: "POST",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["KurumMailGonderimAyarlari"]
        }),
        KurumMailGonderimAyarSil: builder.mutation<boolean, { id: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/KurumMailGonderimAyarSil",
                    method: "DELETE",
                    params: request
                }
            },
            invalidatesTags: ["KurumMailGonderimAyarlari"]
        }),
        KurumMailGonderimAyarDuzenle: builder.mutation<VwKurumMailGonderimAyarlariDTO, VwKurumMailGonderimAyarlariDTO>({
            query: (request) => {
                return {
                    url: controllerName + "/KurumMailGonderimAyarDuzenle",
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["KurumMailGonderimAyarlari"]
        }),
          KurumMailGonderimAyarFiltrele: builder.mutation<Array<VwKurumMailGonderimAyarlariDTO>, VwKurumMailGonderimAyarlariDTO>({
            query: (request) => {
                return {
                    url: controllerName + "/KurumMailGonderimAyarFiltrele",
                    method: "POST",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["KurumMailGonderimAyarlari"]
        })
    })
});

export const {
    useKurumMailGonderimAyarlariListesiQuery,
    useKurumMailGonderimAyarEkleMutation,
    useKurumMailGonderimAyarSilMutation,
    useKurumMailGonderimAyarDuzenleMutation,
    useKurumMailGonderimAyarFiltreleMutation

} = KurumMailGonderimAyarlariApi;